// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XI2k4","delete":"styles_delete__17A4J","update":"styles_update__2zH9S","add":"styles_add__4zmC_"};